/**
 * invalidateAuth — top-level helper to nudge React Query to refetch auth state.
 *
 * Phase 17 Plan 17-03 introduced this so consumers don't hardcode the auth
 * queryKey when they need to recompute auth-derived state after a mutation
 * (e.g. inline-checkout login/register). Per L:/GDB/.claude/rules/react-patterns.md
 * the auth key factory lives in this module — keep its name an implementation
 * detail by routing through this helper.
 *
 * @example
 *   const queryClient = useQueryClient()
 *   await invalidateAuth(queryClient)
 */

import type { QueryClient } from '@tanstack/react-query'
import { authKeys } from './authKeys'

export async function invalidateAuth(queryClient: QueryClient): Promise<void> {
  await queryClient.invalidateQueries({ queryKey: authKeys.all })
}
